// @flow

import { setProps, getProps } from '../props';
import { clearEstimate } from '../State/estimate';
import { setFetching } from '../State/fetching';
import fetchEstimate from '../Services/fetchEstimate';

export default (props: any) => (dispatch: Function) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the estimate ID has changed
  const oldEstimateId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newEstimateId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldEstimateId && newEstimateId && oldEstimateId !== newEstimateId) {
    // Clear the old estimate data and show loading state
    dispatch(clearEstimate());
    dispatch(setFetching(true));
    
    // Fetch the new estimate
    dispatch(fetchEstimate());
  }
};